export default "__VITE_ASSET__C0g7L8eI__"